import { render, staticRenderFns } from "./SingleClaimConfirmationDialog.vue?vue&type=template&id=d0e61a00&scoped=true&lang=pug&"
import script from "./SingleClaimConfirmationDialog.vue?vue&type=script&lang=js&"
export * from "./SingleClaimConfirmationDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0e61a00",
  null
  
)

export default component.exports